import React from "react";

type Props = {
  setSpeed: React.Dispatch<React.SetStateAction<string>>;
  speed: string;
  title: string;
};

function SpeedControl({ speed, setSpeed, title }: Props) {
  return (
    <div className="SCP_Speed">
      <span id="rangeValue">{title}</span>
      <input
        className="range"
        type="range"
        value={speed}
        min="0"
        max="100"
        onChange={(e) => {
          setSpeed(e.target.value);
        }}
      />
    </div>
  );
}

export default SpeedControl;
